import React from 'react';
import { SidebarNavItem } from './SidebarNavItem';
import { NAV_ITEMS, NavItemData } from './sidebarNavItems';

export type { NavItemData };
export { NAV_ITEMS };

/**
 * Pieza del Sidebar: la lista de navegación completa. Ver SidebarNavItem.tsx
 * para una fila individual y Sidebar.tsx para la composición.
 */
export interface SidebarNavProps {
	items?: NavItemData[];
	activeRoute: string;
	isMenuOpen: boolean;
	/** Al pulsar una sección, con su ruta. Quien monta el bloque es quien navega. */
	onNavigate?: (route: string) => void;
}

export const SidebarNav = ({
	items = NAV_ITEMS,
	activeRoute,
	isMenuOpen,
	onNavigate
}: SidebarNavProps) => (
	// `min-h-0` y `overflow-y-auto`: con muchas secciones en una pantalla baja, desplazan dentro de su
	// hueco y el menú de la cuenta sigue a la vista, abajo. `overflow-x-hidden`, porque con el eje
	// vertical en `auto` el horizontal también lo pasa a ser (al desplegar asomaba una barra), y
	// `pb-3` para que el anillo de foco de la última fila no quede cortado.
	<nav
		className={`min-h-0 flex-1 overflow-y-auto overflow-x-hidden pt-3 pb-3 space-y-1 ${
			isMenuOpen ? 'px-3' : 'px-2'
		}`}
	>
		{items.map((item) => (
			<SidebarNavItem
				key={item.route}
				item={item}
				isActive={activeRoute === item.route}
				isMenuOpen={isMenuOpen}
				onNavigate={onNavigate}
			/>
		))}
	</nav>
);
